import { enumToString } from '../util';

// ENUMS
export const PRESCRIPTION_ROUTE = {
  ORAL: { label: 'Oral', value: 0 },
  G_TUBE: { label: 'G Tube', value: 1 },
  J_TUBE: { label: 'J Tube', value: 2 },
  RECTAL: { label: 'Rectal', value: 3 },
  IV: { label: 'IV', value: 4 },
  NG_TUBE: { label: 'NG Tube', value: 5 },
  TOPICAL: { label: 'Topical', value: 6 },
  NEBULIZER: { label: 'Nebulizer', value: 7 },
  OTHER: { label: 'Other', value: 10 },
  toString(value) {
    return enumToString(this, value);
  },
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/medications/constants.js